import swal from 'sweetalert'
import { publicAPI } from '../../config/constants'
import { decrypt, encrypt } from '../../functions/globalFunctions'
import { setDefaultMode } from './generalActions'

import jwt_decode from 'jwt-decode'

export const vendorLogin = (email, password) => {
  return async (dispatch) => {
    try {
      const res = await publicAPI.post(`/vendor-login`, {
        data: encrypt({
          email,
          password,
        }),
      })
      if (res.data) {
        const result = decrypt(res.data)

        let token = jwt_decode(result.token)
        const tokenData = decrypt(token.data)

        localStorage.setItem('token', result.token)
        localStorage.setItem('vendorId', tokenData?.vendorId)
        localStorage.setItem(
          'customer-mode',
          tokenData?.login_offline
            ? 'offline'
            : tokenData?.login_ecommerce
            ? 'ecommerce'
            : 'ecommerceint',
        )
        localStorage.setItem('global-anomalies', false)
        dispatch(setDefaultMode())
        dispatch({
          type: 'VENDOR_INFO',
          payload: tokenData,
        })

        window.location.reload()
        // navigate("/");
      } else {
        swal('', res.data.message, 'error')
      }
    } catch (error) {
      if (error.response.status === 400) {
        const erroe = decrypt(error.response.data)
        swal(erroe.message)
        // swal(error.data.message);
      } else {
        swal('', 'Server Error', 'error')
      }
    }
  }
}
// import axios from "axios";
// import swal from "sweetalert";
// import { url, publicAPI } from "../../config/constants";
// import { setDefaultMode } from "./generalActions";
// import { encrypt, decrypt } from "../../functions/globalFunctions";

// export const vendorLogin = async (email, password, history, dispatch) => {

//   const res = await publicAPI.post(`/vendor-login`, {
//     data: encrypt({
//       email,
//       password,
//     }),
//   });
//
//   if (res.data) {
//     const result = decrypt(res.data);
//     let token = jwt.verify(
//       result.token,
//       process.env.REACT_APP_DATA_DECRYPTION_KEY
//     );
//     const tokenData = decrypt(token.data);
//     localStorage.setItem("token", result.token);
//     // localStorage.setItem("vendorId", tokenData?.vendorId);
//     localStorage.setItem("customer-mode", "offline");
//     // localStorage.setItem("customer-mode", "online");
//     dispatch(setDefaultMode());
//     dispatch({
//       type: "VENDOR_INFO",
//       payload: tokenData,
//     });
//     ;
//     window.location.reload();
//     // navigate("/");
//   } else {
//     swal("", res.data.message, "error");
//   }
// };
